import { render } from "./TranslationTree.vue?vue&type=template&id=3985a86e&scoped=true"
import script from "./TranslationTree.vue?vue&type=script&lang=js"
export * from "./TranslationTree.vue?vue&type=script&lang=js"

import "./TranslationTree.vue?vue&type=style&index=0&id=3985a86e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3985a86e"]])

export default __exports__